import { FogExp2, type Scene } from "three"

export default function createFogExp2(
  scene: Scene,
) {

  // const color = 0x777777
  // const color = 0xcccccc
  // const color = 0xffffff // white
  const color = 0x000000 // black

  // near: The minimum distance to start applying fog. Objects that are less than 'near' units from the active camera won't be affected by fog.
  //   Default is 1.
  // far: The maximum distance at which fog stops being calculated and applied. Objects that are more than 'far' units away from the active camera won't be affected by fog.
  //   Default is 1000
  // new Fog(color, near, far)
  // const fog1 = new Fog(color, 96, 2000)
  // scene.fog = fog1

  // density
  // Default is 0.00025
  const fog2 = new FogExp2(color, 0.003)
  scene.fog = fog2

  // createMountedInverval(() => {
  //   fog.color.setHex(Math.random() * 0xffffff)
  // }, 1000)

  // createMountedInverval(() => {
  //   // scene.fog = fog1 === scene.fog ? fog2 : fog1
  //   // scene.fog = fog1 === scene.fog ? null : fog1
  //   scene.fog = fog2 === scene.fog ? null : fog2
  // }, 1000)
}
